var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from 'react';
import useWebSocket from 'react-use-websocket';
import { getLkWsHost, getReconnectAttempts } from '../../../../../../../Layout/Header/utils';
var RECONNECT_INTERVAL = 10000;
var RECONNECT_ATTEMPTS = getReconnectAttempts();
var wsHost = getLkWsHost();
var WS_LK_NAVIGATION_URL = wsHost + "/ws/navigations";
export var useAppsWs = function (_a) {
    var accessToken = _a.accessToken;
    var _b = __read(useState(!!accessToken), 2), shouldConnect = _b[0], setShouldConnect = _b[1];
    var _c = __read(useState(), 2), apps = _c[0], setApps = _c[1];
    useEffect(function () {
        setShouldConnect(!!accessToken);
    }, [accessToken, setShouldConnect]);
    var ws = useWebSocket(WS_LK_NAVIGATION_URL + "?jwt_token=" + accessToken, {
        share: true,
        fromSocketIO: false,
        shouldReconnect: function () { return true; },
        reconnectInterval: RECONNECT_INTERVAL,
        reconnectAttempts: RECONNECT_ATTEMPTS,
        onMessage: function (e) {
            try {
                var message = JSON.parse(e.data).message;
                setApps(message);
            }
            catch (e) {
                console.error("ws message from lk with url " + WS_LK_NAVIGATION_URL + ", parse error", e);
            }
        },
        onError: function (e) {
            console.error("ws from lk with url " + WS_LK_NAVIGATION_URL + " error", e);
        },
    }, shouldConnect);
    useEffect(function () {
        if (apps) {
            setShouldConnect(false);
        }
    }, [apps, setShouldConnect]);
    return {
        ws: ws,
        apps: apps,
    };
};
//# sourceMappingURL=useAppsWs.js.map